// extracted by mini-css-extract-plugin
module.exports = {"modal":"popup_modal__3wPCG","modal_content":"popup_modal_content__kKQIq","animatezoom":"popup_animatezoom__hSneZ","close":"popup_close__10g0c"};